import React from "react";
import { Form, Select } from 'antd';
import renderOption from "./renderOption";
import { StringUtils } from "../../utils/strings";

const SelectableFormField = ({ name, options, label }) => (
    <Form.Item
      name={name}
      label={label}
      rules={[{ 
        required: true, 
        message: `You need to select a ${name} from the list`
      }]}
    >
    <Select 
        placeholder={`Please select a ${name}`} 
        allowClear 
        showSearch
        filterOption={(input, option) => StringUtils.filterByInput(input, option)}    
    >
        {options.sort().map(renderOption)}
      </Select>
    </Form.Item>
  );

  export default SelectableFormField;